import script from "./CommentMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentMenu.vue?vue&type=script&setup=true&lang=js"

import "./CommentMenu.vue?vue&type=style&index=0&id=f44cce02&lang=scss"

const __exports__ = script;

export default __exports__